import React from 'react';
import ArticleField from '../ArticleField';
import { TextField } from '@material-ui/core';

interface LongHatProps {
    value: string,
    onChange: (value: string) => void
}

const LongHat = (props: LongHatProps) => (
    <ArticleField label="Chapeau long">
        <TextField
            variant="outlined"
            multiline rows={4}
            fullWidth={true}
            required
            value={props.value}
            onChange={(e) => {
                props.onChange(e.target.value);
            }} />
    </ArticleField>
);

export default LongHat;